import { render, staticRenderFns } from "./EpicFhirConfiguration.vue?vue&type=template&id=fc6fc610&scoped=true"
import script from "./EpicFhirConfiguration.vue?vue&type=script&lang=js"
export * from "./EpicFhirConfiguration.vue?vue&type=script&lang=js"
import style0 from "./EpicFhirConfiguration.vue?vue&type=style&index=0&id=fc6fc610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6fc610",
  null
  
)

export default component.exports